// extracted by mini-css-extract-plugin
export var fadeIn = "_kv-1";
export var modalContent = "_kv-3";
export var overlay = "_kv-0";
export var popoverContent = "_kv-2";
export var results = "_kv-5";
export var searchInputWrapper = "_kv-4";